import { JSX, useMemo } from "react";
import { Text } from "@otrium/atoms";
import { Trans } from "@lingui/macro";
import styles from "./RRPFootnote.module.scss";
import { helpCenterLocaleMap } from "src/utils/locale";
import { locale } from "src/config/app-config";

const RRPFootnote = (): JSX.Element => {
  const helpCenterLink = useMemo(
    () => `https://help.otrium.nl/${helpCenterLocaleMap[locale]}/articles/92`,
    []
  );

  return (
    <div className={styles.footnote}>
      <Text as="p" className={styles.text}>
        *&nbsp;
        <Trans>
          {`Strikethrough price = manufacturer's original recommended retail
            price (RRP) for comparison only. RRP may reflect currency conversion
            rates and excludes shipping & platform fee. The promotions we offer
            on our platform are applicable to many of our brands. See
            participating brands in the `}
          <Text
            as="a"
            className={styles.link}
            href={helpCenterLink}
            target="_blank"
            rel="noreferrer"
          >
            Help Centre
          </Text>
          .
        </Trans>
      </Text>
    </div>
  );
};

export default RRPFootnote;
